import { Component, h, Prop } from '@stencil/core';
import AuthHeader from '../auth-header';
import { i18n } from "../../../utils/i18n";

@Component({
  tag: 'hd-logout',
  shadow: false,
})
export class HdLogout {
  @Prop() email: string;
  t = i18n.get("hd-auth");

  logout = () => {
    window.AD.logout_options = {
      redirect_after: window.location.href
    }
    window.AD?.logout();
  }

  render() {
    return (
      <div class="logout-container step-container">
        <AuthHeader
          title={this.t("logout.title")}
          subhead={this.t("logout.subtitle", { email: this.email })}
        />
        <div class="step-actions">
          <button class="next-step" onClick={this.logout}>
            {this.t("logout.button")}
          </button>
        </div>
      </div>
    );
  }
}
